import { Configuration } from "product-test-types";

import { STRAPI_URL } from "../env";

export async function fetchEntityConfiguration(): Promise<
  Configuration | undefined
> {
  try {
    const response = await fetch(`${STRAPI_URL}/configuration`, {
      credentials: "include",
    });

    if (response.status >= 400) {
      throw new Error(`Fetch failed with status ${response.status}.`);
    }

    const json = (await response.json()) as Configuration;

    return json;
  } catch {
    return;
  }
}

export async function createConfiguration(
  configuration: Configuration
): Promise<Configuration | undefined> {
  try {
    const response = await fetch(`${STRAPI_URL}/configuration`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(configuration),
    });

    if (response.status >= 400) {
      throw new Error(`Fetch failed with status ${response.status}.`);
    }

    const json = (await response.json()) as Configuration;

    return json;
  } catch {
    return;
  }
}
